import React, {
  useCallback,
  useState,
} from 'react';

import UserTable from '../../components/UserTable';
import { withIdsSelected } from '../../utils/selection';

import {
  Container,
  Title,
  Header,
  TableContainer,
  Description,
  ContentRow,
} from './styles';
import texts from './texts.json';
import UserTypeButtons from './components/UserTypeButtons';

const ManageClientsDashboard = () => {
  const [selectedClients, setSelectedClients] = useState([]);

  const handleClientListUpdate = useCallback((clientId) => {
    setSelectedClients((prevSelectedClients) => {
      if (prevSelectedClients.includes(clientId)) {
        return prevSelectedClients.filter((id) => id !== clientId);
      }

      return [...prevSelectedClients, clientId];
    });
  }, [setSelectedClients]);

  const handleClientsSelectionChange = useCallback((clientIds, isSelected) => {
    setSelectedClients((prevSelectedClients) => withIdsSelected(prevSelectedClients, clientIds, isSelected));
  }, [setSelectedClients]);

  return (
    <Container>
      <Header>
        <Title>{texts.manageClientsTitle}</Title>
        <ContentRow>
          <Description>{texts.manageClientsDescription}</Description>
          <UserTypeButtons />
        </ContentRow>
      </Header>
      <TableContainer>
        <UserTable
          setSelectedClients={handleClientListUpdate}
          onClientsSelectionChange={handleClientsSelectionChange}
          selectedClients={selectedClients}
        />
      </TableContainer>
    </Container>
  );
};

export default ManageClientsDashboard;
